// it has to be called messages...https://github.com/kazupon/vue-i18n/issues/244
const tc = {
  message: {
    choose_date_time: "選擇日期及時間",
    choose_tickets: "選擇門票 | 選擇門票 | 選擇 {count} 張門票",
    ticket_delivery: "郵寄地址",
    empty_basket: "你未選購任何項目",
    shopping_cart: "購物籃",
    choose_seating_area: "請選擇座位分區",
    newsletter_signup:
      "本人同意訂閱《西九藝訊》電子通訊<br><br>我們有意使用閣下提供的個人資料提供給你西九文化區的活動及節目資訊。若你同意有關使用，請在上面空格內劃上剔號。你可隨時根據「<a href='https://www.westk.hk/tc/privacy#pics' target='_blank'>收集個人資料聲明</a>」取消訂閱，或查閱或改正你的個人資料。",
    choose_seats: "請於{sectionAlias}選擇座位",
    budget_per_ticket: "票價",
    ticket_quantity_header: "門票數量",
    ticket_quantity_body: "你想購買多少張門票？",
    best_available_body: "藍色標示的兩組座位是推薦選項，請點選並按「確定座位」繼續。",
    hot_show_body: "黃色標示的座位是推薦選項，請點選並按「確定座位」繼續。",
    calendar_prompt: "請從標示的日子中，",
    calendar_instruction: "選取你想要的日期和時間",
    confirmation_screen: "購票確認",
    register_success: "感謝閣下登記是次活動",
    register_confirmation_email: "我們將發電郵至閣下的電子郵箱以茲確認",
    booking_reference: "交易編號",
    download_eticket: "下載你的電子門票",
    privacy_policy:
      "提交此表格代表我已詳細閱讀及完全明白並同意受「<a href='https://www.westk.hk/tc/termsandconditions' target='_blank'>條款及細則</a>」之約束，以及同意局方可根據「<a href='https://www.westk.hk/tc/privacy' target='_blank'>私隱政策</a>」使用於本表格上提供的個人資料。",
    payment_method: "付款方式",
    booking_date: "交易日期",
    help: "幫助",
  },
  payment: {
    payment_details: "請選擇付款方式",
    payment_failed: "付款失敗",
    payment_failed_explanation: "交易失敗。我們無法處理您的付款。請重新嘗試。",
    order_confirmation: "訂單已確認！感謝你的訂購。確認電郵已發送至{email}",
    order_summary: "訂單摘要",
    subtotal: "小計",
    delivery_cost: "郵費",
    total: "總計",
    donate_link: "支持西九文化區",
    customer_portal: "請查閱「我的活動」檢視已購買的訂單。",
    pdf_link: "下載你的電子門票",
    continue_shopping: "繼續選購",
    quantity: "數量",
    unit_price: "票價",
    booking_fee: "手續費",
    ticket_details: "詳情",
    no_cost: "你購物籃內的項目無須收費，請按「繼續」以完成訂購。",
  },
  payment_methods: {
    JCB_WKCD_ONLINE: "JCB",
    CUP_WKCD_ONLINE: "銀聯卡在線支付",
    AMEX_WKCD_ONLINE: "美國運通",
    VISA_WKCD_ONLINE: "Visa",
    MASTER_WKCD_ONLINE: "Mastercard",
  },
  newsletter: {
    button: "訂閱",
    placeholder: "您的電郵地址",
  },
  announcement: {
    title: "通知",
    null_str: "暫時沒有通知",
    view_all: "查看所有",
  },
  availability: {
    sold_out: "售罄",
    available: "可選",
    limited_seats: "座位有限",
    single_seat: "單人座位",
  },
  event: {
    status: {
      available: "門票",
      limited: "尚餘少量",
      sold_out: "售罄",
      cancelled: "節目取消",
      postponed: "節目延期",
      coming_soon: "即將發售",
      temporarily_off_sale: "暫時停售",
    },
  },
  session: {
    status: {
      coming_soon: "即將接受報名",
      registration_closed: "已截止登記",
      full: "名額已滿",
      full_extended: "本活動沒有足夠報名名額。",
      temporarily_unavailable: "暫時未能提供",
    },
  },
  ticket: {
    add_ticket: "增加 1 張門票",
    remove_ticket: "減少 1 張門票",
    discount_code: "請輸入推廣優惠密碼。",
    quantity: "數量",
    price: "票價",
    type: "門票種類",
    failed_to_add_to_cart: "無法加入購物籃",
    successfully_added_to_cart: "成功加入購物籃",
  },
  register: {
    register_title: "報名表格",
    register_description: "已註冊MyWestKowloon帳戶？立即登入，讓登記活動更快捷方便。",
    newsletter:
      "本人選擇不接收西九文化區電子通訊，包括但不限於有關會員禮遇、商店／商品推廣及活動邀請的最新消息。<br><br>局方擬根據「<a href='https://www.westk.hk/tc/about-us/privacy' target='_blank'>私隱政策</a>」，於局方內部及與特選合作夥伴共享使用閣下的個人資料，發送與產品、活動、節目及服務有關的推廣訊息。 ",
    submit: "立即報名",
    select_session_title: "選擇日期及時間",
    not_this_user: "不是 {name} 嗎？",
    registration_complete: "繼續瀏覽節目及活動",
    registration_sign_up_prompt: " 註冊帳戶",
    help_text: "必填項目",
  },
  timer: {
    timer_text_1: "預訂座位只保留",
    timer_text_2: "分鐘",
  },
  buttons: {
    seat_area_and_tickets: "下一步",
    view_calendar: "查看日曆",
    add_to_basket: "加入購物籃",
    payment_method: "下一步",
    return_to_website: "返回網頁",
    checkout: "確認訂購",
    save_basket_and_continue: "繼續購買",
    ok_continue: "確定",
    go_back: "返回",
    close: "關閉",
    choose_seats: "下一步",
    confirm_seats: "下一步",
    ok_got_it: "確定",
    hide_calendar: "隱藏日曆",
    zoom_in: "放大",
    zoom_out: "縮小",
    zoom_reset: "重設",
    add_link_text: "購買更多門票",
    ok: "確定",
    back: "返回",
  },
  footer: {
    copyright: "WestK及WestK標誌均為西九文化區管理局的商標。",
    copyright_2: " 西九文化區管理局。保留所有權利。",
    links: {
      privacy: "私隱政策",
      ts_and_cs: "條款及細則",
      freedom_of_information: "網站資訊",
      contact: "聯絡我們",
      join_in: "關注我們",
    },
  },
  modal: {
    cart_timer_warning: "你的選購時間尚餘5分鐘",
    cart_timer_body: "你的購物籃將於5分鐘後自動清空。如閣下未能於限定時間內完成交易，已選門票將會被取消。",
    ticket_advisory_title: "告示",
    choose_area: {
      availability: "座位供應情況",
      category: "票價",
      section: "分區",
    },
    accessible_zone: {
      title: "無障礙區",
      message:
        "你剛選擇的座位在無障礙區，僅供輪椅使用者及其陪同者使用。我們保留拒絕非合資格人士進場或調動其座位的權利。如確定，即代表你已明白你所選的座位對象，及選購的門票供輪椅使用者及其陪同者使用。",
    },
    members_only: {
      title: "你已選取會員門票",
      no_valid_membership: "所選擇的門票種類只適用於特定的會籍類別，請選擇其他門票種類。",
      quota_reached: "你選擇的會員門票超出你可兌換的數量，請修改或選擇其他門票種類。",
      connection_issue: "無法連接會員系統，請稍後再試。",
      further_information: "查看更多",
      select_non_member_tickets: "揀選非會員門票",
    },
    hkid_warning_header: "閣下須持有人香港身份證以享有折扣優惠。",
    hkid_warning_body: "在入場前，閣下或須出示有效之香港身份證。",
    delete_confirm_title: "你確定想移除此項目？",
    delete_confirm_text: "確定移除此項目後，您可能無法再次選取相同的項目。",
  },
  account: {
    overview: "概覽",
    events: "我的活動",
    profile: "我的帳戶",
    logout: "登出",
    hello: "你好",
    sign_in: "登入",
    new_customer: "新用戶?",
    start_here: "馬上註冊",
    your_account: "你的帳戶",
    login: "登入",
    shoppingCart: "購物籃",
    myEvent: "我的活動",
  },
  errors: {
    select_all_tickets: "門票種類的數量須與已選座位的數量相同，請選擇 {count} 張門票",
    max_allowed_tickets: "您不能選擇多於({count}) 張門票。",
    invalid_discount_code_format: "請輸入正確的推廣優惠碼。",
    fix_errors: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    no_seating_area_selected: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    seating_area_failed: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    retrieve_seat_options: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    date_times_retrieval_failed: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    ticket_type_retrieval_failed: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    delivery_method_retrieval_failed: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    shopping_cart_submission_failed: "系統出現錯誤，請稍後再試。(加入購物籃失敗)",
    shopping_cart_items_retrieval_failed: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    select_a_set: "請選擇座位.",
    too_many_tickets: "你最多只能選擇40個座位。",
    reserve_tickets_failed: "系統出現錯誤，請稍後再試。（無法預留座位）",
    required_field: "* 必填項目",
    some_tickets_werent_added: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    cart_confirmation: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    seat_offers_failed_other: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    ticket_type_available_quantity: "所選擇的數量不正確。",
    registration_submission_failed: "無法完成登記，請稍後再試。",
    registration_generic_error: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    generic_error: "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
    invalid_email: "請輸入有效的電郵",
    crm: {
      sip: {
        error: {
          "401001": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "401002": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "401003": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "404001": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "405001": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "500100": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "400001": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "400500": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "500001": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "500200": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "500201": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "410001": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
          "400701": "非常抱歉，購票過程出現錯誤，請稍候並重新嘗試。如問題持續，請致電票務熱線（852）2200 0022。",
        },
        "no-vacancy": "本活動沒有足夠報名名額。",
      },
    },
    sistic: {
      error: {
        cart: {
          "add-event": {
            "mix-not-allowed": "無法新增項目至購物籃，請先完成購買已放入購物籃的項目。",
          },
          "add-to-cart": {
            fail: "系統出現錯誤，請稍後再試。(加入購物籃失敗)",
            product: {
              "no-config": "系統出現錯誤，請稍後再試。 (沒有設定)",
            },
            "quota-reached": "系統出現錯誤，請稍後再試。(超過活動門票最大數量)",
          },
          barcode: {
            retrieval: {
              fail: "系統出現錯誤，請稍後再試。(條碼定義和條碼字段)",
            },
          },
          "exceed-allocation": "系統出現錯誤，請稍後再試。(超出購物籃的節目數量上限)",
          "exceed-max-qty": "所選的門票種類超過限購數量。",
          inventory: {
            check: {
              fail: "系統出現錯誤，請稍後再試。(計算庫存時出錯)",
            },
            duplicates: "系統出現錯誤，請稍後再試。(在購物籃中找到重複項目)",
            empty: "系統出現錯誤，請稍後再試。(庫存清單是空的)",
            "groupbooking-ga": {
              "not-found": "",
            },
            "quantity-price-class": {
              mismatch: "系統出現錯誤，請稍後再試。(庫存和價格的數量不符)",
            },
          },
          "new-event": {
            "mix-not-allowed": "無法新增項目至購物籃，請先完成購買已放入購物籃的項目。",
          },
          "not-found": "系統出現錯誤，請稍後再試。(沒有找到購物籃)",
          order: {
            "cart-total-amount": {
              mismatch: "系統出現錯誤，請稍後再試。(購物籃項目總金額不符)",
            },
            "delivery-charge": {
              mismatch: "系統出現錯誤，請稍後再試。(運費不符)",
            },
            generic: "系統出現錯誤，請稍後再試。(無法處理您的訂單)",
            "not-found-expired": "系統出現錯誤，請稍後再試。(訂單參考編號尚未找到或過期)",
            "paid-amount": {
              mismatch: "系統出現錯誤，請稍後再試。(訂單參考編號支付金額不符)",
            },
            "product-total-amount": {
              mismatch: "系統出現錯誤，請稍後再試。(產品總量不符)",
            },
            seat: {
              "not-available": "系統出現錯誤，請稍後再試。(座位無法使用)",
              reserve: {
                fail: "系統出現錯誤，請稍後再試。(無法預留座位)",
              },
            },
          },
          postcommit: {
            "calculated-precommit-amount": {
              mismatch: "系統出現錯誤，請稍後再試。(總金額不符)",
            },
            "exceed-quota": "購物籃內的項目超過限購數量。",
            fail: "系統出現錯誤，請稍後再試。(無法確認訂單)",
            inventory: {
              unavailable: "系統出現錯誤，請稍後再試。(座位可能未能確認)",
            },
          },
          precommit: {
            "creditcard-delivery-method": {
              invalid: "此信用卡不適用於所選的領取方法。",
            },
            "creditcard-price-class": {
              invalid: "此信用卡不適用於所選的門票種類。",
            },
            "delivery-method": {
              invalid: "系統出現錯誤，請稍後再試。(領取方法無效)",
              "no-fee-config": "系統出現錯誤，請稍後再試。(領取方法尚未設定收費)",
            },
            "mailing-address": {
              invalid: "系統出現錯誤，請稍後再試。 (郵寄國家/地區無效)",
            },
            "payment-method": {
              creditcard: {
                invalid: "此信用卡不適用於所選的付款方式。",
              },
              invalid: "無法完成交易。請使用其他付款方式。",
            },
            "product-offsales": "系統出現錯誤，請稍後再試。(暫時停止銷售)",
          },
          promo: {
            code: {
              "hold-code": {
                "no-config": "推廣優惠代碼無效。",
              },
              invalid: "推廣優惠代碼無效。",
              popup: {
                text: "推廣優惠代碼無效。",
              },
              "price-class": {
                mismatch: "系統出現錯誤，請稍後再試。(未與推廣優惠代碼綁定)",
              },
            },
            password: {
              empty: "必須輸入推廣優惠密碼。",
              inactive: "系統出現錯誤，請稍後再試。(推廣優惠密碼未啟用)",
              incorrect: "推廣優惠密碼錯誤。",
              invalid: "推廣優惠密碼無效。",
              "quota-reached": "推廣優惠密碼超過使用上限。",
            },
          },
          "qty-config": {
            qty: {
              mismatch: "所選擇的數量不正確。",
            },
          },
          "sales-quota": {
            transaction: {
              exceeded: "訂單無法處理。你所選購的門票現已沽清，請重新選擇其他門票種類 。為你造成不便，我們深感抱歉。",
            },
          },
          "top-status": {
            payment: {
              fail: {
                firstdata: "交易失敗。我們無法處理您的付款。請重新嘗試。",
              },
            },
          },
        },
        product: {
          "detail-seatmap": {
            generation: {
              coordinate: {
                missing: "系統出現錯誤，請稍後再試。(座位圖內容 - 坐標)",
              },
              fail: "系統出現錯誤，請稍後再試。(座位圖細節錯誤)",
              seatangle: {
                missing: "系統出現錯誤，請稍後再試。(座位圖內容 - 座位角度)",
              },
            },
            insufficient: "系統出現錯誤，請稍後再試。(座位不足)",
          },
          icc: {
            invalid: "對不起，此活動已結束。有關西九的最新活動資訊，請瀏覽本網站「<a href='https://www.westk.hk/tc/whats-on/' target='_blank'>節目及活動</a>」。",
            "not-found": "對不起，此活動已結束。有關西九的最新活動資訊，請瀏覽本網站「<a href='https://www.westk.hk/tc/whats-on/' target='_blank'>節目及活動</a>」。",
          },
          "no-common-delivery": "系統出現錯誤，請稍後再試。(没有找到常用的領取方法)",
          "no-common-delivery-payment": "系統出現錯誤，請稍後再試。(没有找到常用的領取方法和付款方式)",
          "no-common-payment": "系統出現錯誤，請稍後再試。(没有找到常用的付款方式)",
          "overview-seatmap": {
            generation: {
              fail: "系統出現錯誤，請稍後再試。(產生概覽座位圖)",
            },
          },
          param: {
            icc: {
              missing: "系統出現錯誤，請稍後再試。(遺失的互聯網內容碼)",
            },
            mode: {
              missing: "系統出現錯誤，請稍後再試。(遺失的活動模式)",
            },
            "price-cat-id": {
              missing: "系統出現錯誤，請稍後再試。(遺失的價格類別ID)",
            },
            "product-id": {
              missing: "系統出現錯誤，請稍後再試。(遺失的產品ID)",
            },
            quantity: {
              missing: "系統出現錯誤，請稍後再試。(數量不足)",
            },
            "seat-section-id": {
              missing: "系統出現錯誤，請稍後再試。(遺失的座段ID)",
            },
          },
          seats: {
            release: "系統出現錯誤，請稍後再試。(釋放座位時出錯)",
            reserve: "系統出現錯誤，請稍後再試。(預訂座位時出錯)",
          },
          "updated-event": {
            "not-found": "系統出現錯誤，請稍後再試。(未找到活動更新)",
          },
        },
      },
    },
  },
  language: {
    selected: "請選擇語言。現時設定為繁體中文。",
  },
  delivery_details: {
    delivery_address_1: "地址第一行",
    delivery_address_2: "地址第二行",
    delivery_address_3: "地址第三行",
    postcode: "郵政編碼",
    select_a_country: "請選擇國家 / 地區",
  },
  delivery_warning: {
    hong_kong_only: "香港特別行政區",
    macau_only: "澳門特別行政區",
  },
  delivery_methods: {
    KIOSK_OFFICE_PICKUP_WKCD: {
      title: "親臨場地票務處或自助售票機領取門票",
      description: "顧客需攜帶交易時使用之信用卡、交易編號及電郵地址，親臨場地售票處或自助售票機領取門票。請注意個別節目之特別要求。",
    },
    COURIER_HK: {
      title: "速遞（香港）",
      description: "送遞門票時，收件人須簽收確認。",
    },
    COURIER_MC: {
      title: "速遞（澳門）",
      description: "送遞門票時，收件人須簽收確認。",
    },
    COURIER_ML1: {
      title: "速遞（中國內地）",
      description: "送遞門票時，收件人須簽收確認。",
    },
    COURIER_OS1: {
      title: "速遞（海外）",
      description: "門票配送上門時（香港、澳門、中國內地除外），須收件人簽收作實。",
    },
    E_TICKET: {
      title: "電子門票",
      description: "系統將發送確認電郵至您所提供的電郵地址，並附上PDF電子門票。屆時請點擊電郵上的連結，下載電子門票。",
    },
    REGISTERED_MAIL_HK: {
      title: "掛號（香港）",
      description: "送遞門票時，收件人須簽收確認。",
    },
    REGISTERED_MAIL_OS: {
      title: "掛號（海外）",
      description: "送遞門票時，收件人須簽收確認。",
    },
    BLANK_DELIVERY_OPTION: {
      title: "請選擇領取門票方式",
    },
  },
  seats_legend: {
    available: "可選",
    unavailable: "不可選",
    selected: "已選",
    offered: "座位提供",
  },
  seating_selection_info: {
    your_selection: "你選擇了",
    row: "行",
    seat: "座位",
    selected: "",
  },
  search: {
    placeholder: "站內搜尋...",
    cta: "搜尋",
  },
  header: {
    logged_in: {
      text: "登出後你在購物籃裡的項目將會被移除。",
    },
  },
};

export default tc;
